import { Component, OnInit, Input } from "@angular/core";
import { forkJoin } from "rxjs";
import _ from "lodash";
import * as moment from "moment";
import { NzModalRef, NzModalService } from "ng-zorro-antd/modal";
import { NzMessageService } from "ng-zorro-antd/message";

import {
  SearchDateAndHouseService,
  IGetHouses,
} from "@root/component/search-components/search-date-and-house/search-date-and-house.service";
import { TranslateService } from "@root/shared/service/translate.service";
import { DateService } from "@root/shared/service/date.service";

interface IRange {
  begin: string;
  end: string;
}

/**
 * @deprecated
 */
@Component({
  selector: "host-search-date-and-house",
  templateUrl: "./search-date-and-house.component.html",
  styleUrls: ["./search-date-and-house.component.scss"],
})
export class SearchDateAndHouseComponent implements OnInit {
  @Input() defaultHouses: Array<number> = null; // 修改某一条信息时，该信息已选择的房间
  @Input() selectedHouses: Array<number> = null; // 一条手工单中，其它条信息，已选择的房间们
  @Input() defaultDate: IRange = null; // 修改某一条信息时，该信息已选择的时间区间
  @Input() dateType: "range" | "single" = "range";

  dateInfo;
  finalCheckedDateRange;
  // houseInfo = '0个房间';
  houseInfo = this.translateService.syncGet("component.search.select_no_house");
  finalCheckedhouses;
  checkedInfo = {
    date: null,
    houses: null,
  };

  houseGroupList = [];
  houseTypeList = [];
  allHouseList = [];
  activeIndex = 0;
  allowMultiSelect = false;

  params: IGetHouses = {
    page: 1,
    page_size: 10000,
    format: "create_order_reservation",
    type: "house_status",
    physical_status: 3,
    house_type_id: null,
    group_id: null,
    begin: null,
    end: null,
  };

  constructor(
    private modalRef: NzModalRef,
    private housesService: SearchDateAndHouseService,
    private messageService: NzMessageService,
    private modalService: NzModalService,
    private translateService: TranslateService,
    private dateService: DateService,
  ) {}

  ngOnInit() {
    this.getAllList();
    if (this.selectedHouses) {
      this.allowMultiSelect = true;
    }
  }

  getAllList() {
    forkJoin([this.housesService.getGroupList(), this.housesService.getHouseTypeList()]).subscribe((res) => {
      if (res) {
        this.houseGroupList = this.initGroupList(_.get(res[0], "data.list"));
        this.houseTypeList = this.initTypeList(_.get(res[1], "data.list"));
      }
    });
  }

  getHouseList() {
    this.housesService.getHousesList(this.params).subscribe((res) => {
      if (res.error_code === 0) {
        this.allHouseList = this.initHouseList(_.get(res, "data.list"));
      }
    });
  }

  initGroupList(data) {
    const temp = [];
    temp.push({
      thisGroupChecked: false,
      // name: '全部分组',
      name: this.translateService.syncGet("house.all_group"),
      id: -1,
    });
    for (let i = 0; i < data.length; i++) {
      temp.push({
        thisGroupChecked: false,
        name: data[i].name,
        id: data[i].group_id,
      });
    }
    return temp;
  }

  initTypeList(data) {
    if (data.length === 0) {
      return data;
    }
    const temp = [];
    temp.push({
      thisTypeChecked: false,
      // title: '全部房型',
      title: this.translateService.syncGet("component.relate.all_house_types"),
      id: -1,
    });
    _.forEach(data, (type) => {
      temp.push({
        ...type,
        thisTypeChecked: false,
      });
    });
    return temp;
  }

  initHouseList(data) {
    const temp = [];
    _.forEach(data, (type) => {
      _.forEach(type, (house) => {
        _.assign(house, {
          checked: false,
          disabled: false,
        });
      });
      temp.push(type);
    });
    return temp;
  }

  statusChange() {
    const status = this.activeIndex === 0 ? 3 : this.activeIndex === 1 ? 2 : 1;
    _.assign(this.params, {
      physical_status: status,
    });
    this.getHouseList();
  }

  groupChange(id) {
    _.assign(this.params, {
      house_type_id: null,
      group_id: id,
    });
    this.getHouseList();
  }

  typeChange(id) {
    _.assign(this.params, {
      house_type_id: id,
      group_id: null,
    });
    this.getHouseList();
  }

  dateChange(value) {
    if (this.dateType === "range" && value.end) {
      this.finalCheckedDateRange = value;
      _.assign(this.params, {
        begin: value.start,
        end: value.end,
      });
      this.getHouseList();
      const len = value.start === value.end ? 1 : value.rangeLen - 1;
      // this.dateInfo = `已选 ${moment(value.start).format('MM.DD')}-${moment(value.end).format('MM.DD')} 共${len}晚`;
      this.dateInfo =
        len > 1
          ? this.translateService.syncGet("component.search.selected_days", {
              start: this.dateService.format(moment(value.start), ["MD"]),
              end: this.dateService.format(moment(value.end), ["MD"]),
              len: len,
            })
          : this.translateService.syncGet("component.search.selected_day", {
              start: this.dateService.format(moment(value.start), ["MD"]),
              end: this.dateService.format(moment(value.end), ["MD"]),
              len: len,
            });
    } else if (this.dateType === "single" && _.get(value, "date")) {
      const date = value.date;
      this.finalCheckedDateRange = {
        start: date,
        end: date,
        rangeLen: 1,
      };
      _.assign(this.params, {
        begin: date,
        end: date,
      });
      this.getHouseList();
      const formatDate = this.dateService.format(moment(date), ["YMD"]);
      this.dateInfo = `已选${formatDate}`;
    } else {
      this.finalCheckedDateRange = null;
    }
  }

  checkedHousesChange(houses) {
    console.log(houses);
    this.finalCheckedhouses = houses;
    // this.houseInfo = `${houses.length}个房间`;
    this.houseInfo =
      houses.length > 1
        ? this.translateService.syncGet("component.search.houses_total", {
            total: houses.length,
          })
        : this.translateService.syncGet("component.search.house_total", {
            total: houses.length,
          });
  }

  cancel() {
    this.modalRef.destroy();
  }

  save() {
    if (!this.finalCheckedhouses || this.finalCheckedhouses.length === 0) {
      // 请选择房间
      const warningText = this.translateService.syncGet("errorText.house_required");
      this.messageService.warning(warningText);
      return;
    }
    if (!this.finalCheckedDateRange) {
      // 请选择日期
      const warningText = this.translateService.syncGet("errorText.choose_date_required");
      this.messageService.warning(warningText);
      return;
    }
    const houses = _.map(this.finalCheckedhouses, "id");
    const params = {
      house_ids: `[${houses}]`,
      begin: this.finalCheckedDateRange.start,
      end: this.finalCheckedDateRange.end,
    };
    this.housesService.getHousesReservationStatus(params).subscribe((res) => {
      if (res.error_code === 0) {
        if (_.get(res, "data.has_reservation")) {
          this.modalService.warning({
            // nzTitle: "部分房间已被占用",
            nzTitle: this.translateService.syncGet("warning.some_houses_occupied"),
            // nzContent: "如果在已被占用的房间上新建订单，订单将进入订单盒子。",
            nzContent: this.translateService.syncGet("warning.some_houses_occupied_info"),
            nzCancelText: this.translateService.syncGet("word.cancel"),
            nzOkText: this.translateService.syncGet("word.confirm"),
            nzOnOk: () => this.chooseFinished(),
          });
        } else if (_.get(res, "data.has_unavailability")) {
          this.modalService.warning({
            // nzTitle: "部分房间的房态已关闭",
            nzTitle: this.translateService.syncGet("warning.some_house_status_closed"),
            // nzContent: "如果继续操作将在已经关闭的房间上创建订单。",
            nzContent: this.translateService.syncGet("warning.some_house_status_closed_info"),
            nzCancelText: this.translateService.syncGet("word.cancel"),
            nzOkText: this.translateService.syncGet("word.confirm"),
            nzOnOk: () => this.chooseFinished(),
          });
        } else {
          this.chooseFinished();
        }
      }
    });
  }

  chooseFinished() {
    this.modalRef.destroy({
      date: {
        begin: this.finalCheckedDateRange.start,
        end: this.finalCheckedDateRange.end,
        rangeLen: this.finalCheckedDateRange.rangeLen,
      },
      houses: this.finalCheckedhouses,
    });
  }
}
